/* Accessibility behavior for navigation and app launchers.
 * Keep the compiled theme's menu transitions; synchronize their semantic state.
 */
(() => {
  const menu = document.querySelector('mobile-menu');
  const toggle = document.getElementById('mobile-menu-toggle');
  const mobile = window.matchMedia('(max-width: 1023px)');
  const focusable = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]';
  const visible = (el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert], [hidden]');

  if (menu && toggle) {
    let wasOpen = false;
    const backgroundStates = new Map();
    menu.querySelectorAll('.indicator').forEach((button, index) => {
      const panel = button.parentElement.nextElementSibling;
      if (!panel || !panel.classList.contains('children')) return;
      panel.id ||= `mobile-submenu-${index}`;
      button.setAttribute('aria-controls', panel.id);
      const sync = () => {
        const open = panel.classList.contains('max-h-screen');
        button.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
      };
      new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
      sync();
    });

    function syncMenu() {
      const open = mobile.matches && document.body.classList.contains('mobile-menu-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      toggle.title = open ? 'Close menu' : 'Open menu';
      menu.inert = !open;
      menu.setAttribute('aria-hidden', String(!open));
      if (open && !wasOpen) {
        document.querySelectorAll('main, #MainContent, .shopify-section-group-footer-group').forEach((el) => {
          backgroundStates.set(el, el.inert);
          el.inert = true;
        });
        menu.querySelector('input[type="search"]')?.focus();
      }
      if (!open && wasOpen) {
        backgroundStates.forEach((inert, el) => { el.inert = inert; });
        backgroundStates.clear();
        if (mobile.matches) toggle.focus();
      }
      wasOpen = open;
    }
    new MutationObserver(syncMenu).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    mobile.addEventListener('change', () => {
      if (!mobile.matches && document.body.classList.contains('mobile-menu-open')) toggle.click();
      syncMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (!wasOpen || (event.target !== toggle && !menu.contains(event.target))) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        toggle.click();
      } else if (event.key === 'Tab') {
        const controls = [toggle, ...menu.querySelectorAll(focusable)].filter(visible);
        const index = controls.indexOf(document.activeElement);
        event.preventDefault();
        controls[(index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length]?.focus();
      }
    });
    syncMenu();
  }

  const labelRewards = () => {
    const button = document.getElementById('bon-loyalty-btn');
    if (button && button.getAttribute('aria-label') !== 'Open rewards') button.setAttribute('aria-label', 'Open rewards');
  };
  function labelCarousels() {
    document.querySelectorAll('.scroll-indicators').forEach((group) => {
      const links = group.querySelectorAll('a.scroll-indicator');
      const heading = group.closest('.shopify-section')?.querySelector('h2')?.textContent.trim();
      links.forEach((link, index) => {
        link.setAttribute('aria-label', (heading ? heading + ': ' : '') + 'Go to slide ' + (index + 1) + ' of ' + links.length);
      });
    });
  }
  const labelControls = () => { labelRewards(); labelCarousels(); };
  labelControls();
  new MutationObserver(labelControls).observe(document.body, { childList: true, subtree: true });
})();
